<div class="stk-login">
    <form class="stk-login__card" (ngSubmit)="login()">
        <div class="stk-login__logo">
            <img src="../../../assets/stokker_logo_transparent.png" alt="Stokker">
        </div>
        <label class="stk-login__label" for="login-username">Felhasználó</label>
        <input id="login-username" type="text" class="stk-login__input" [(ngModel)]="username" name="username" autocomplete="username">
        <label class="stk-login__label" for="login-password">Jelszó</label>
        <input id="login-password" type="password" class="stk-login__input" [(ngModel)]="password" name="password" autocomplete="current-password">
        <button type="submit" class="stk-login__submit" [disabled]="loading">
            {{ loading ? 'Belépés…' : 'Belépés' }}
        </button>
        <p class="stk-login__error">
            <span *ngIf="showError">Bejelentkezés sikertelen!</span>
        </p>
    </form>
</div>
